import { EntityCommand, EntityCommandPropertyValues, EntityCommandTypeEnum, IEntityCommand } from "@seriously-rad/seriouslyrad-framework-core/EntityCommand";
import { EntityCommandInformation } from "@seriously-rad/seriouslyrad-framework-core/EntityCommandInformation";
import { PartialNullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { Property } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { PermissionEvaluator } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework.Data.Entities/Evaluation/Evaluators/PermissionEvaluator";
import { DialogResultEnum } from "@seriously-rad/seriouslyrad-framework-core/Ui/Dialogs/DialogResultEnum";
import { CaseEmailFilterParameterDialog } from "../Ui/Dialogs/CaseEmailFilterParameterDialog";

export type EntityCommandCaseEmailFilterPropertyValues =
    EntityCommandPropertyValues
    & {
    };

export type EntityCommandCaseEmailFilterProperties = {
    [name in keyof EntityCommandCaseEmailFilterPropertyValues]: Property<EntityCommandCaseEmailFilterPropertyValues[name]>
};

export interface IEntityCommandCaseEmailFilter extends IEntityCommand, EntityCommandCaseEmailFilterProperties
{
}

export class EntityCommandCaseEmailFilter extends EntityCommand implements IEntityCommandCaseEmailFilter
{
    // #region Static

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<EntityCommandCaseEmailFilterPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                description: "Filter",
                entityName: "CaseEmail",
                key: "FILTER",
                permission: PermissionEvaluator.permissionLevels.read,
                type: EntityCommandTypeEnum.entitySet,
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Overrides

    protected override async _executeAsync(entityCommandInformation: EntityCommandInformation, value?: any)
    {
        await super._executeAsync(entityCommandInformation, value);

        const
            caller = entityCommandInformation.caller.get();

        if (!caller.caseEmailFilterParameterDialog)
            caller.caseEmailFilterParameterDialog = new CaseEmailFilterParameterDialog();

        const
            caseEmailFilterParameterDialog = caller.caseEmailFilterParameterDialog as CaseEmailFilterParameterDialog;

        await (
            caseEmailFilterParameterDialog
                .openAsync()
                .then(result =>
                {
                    if (result.dialogResult !== DialogResultEnum.ok)
                        return;

                    caller.currentFilter = result.promiseData;
                })
        );
    }

    // #endregion

    // #endregion
}

